import { StemType } from '@arpeggi/shared'
import { observer } from 'mobx-react-lite'
import React, { FC } from 'react'
import { useTreeState } from '../../../stores/Root'
import { INoteCollectionStore } from '../../../stores/song/loop/NoteCollectionStore'
import { IStemStore } from '../../../stores/song/StemStore'
import useCanvasVisualizer from './useCanvasVisualizer'

interface MidiVisualizerProps {
  stem: IStemStore
  loopNumber: number
  fill: string
  style?: React.CSSProperties
}

// Visualize a loop based on the loop number of a stem
export const MidiVisualizer: FC<MidiVisualizerProps> = observer(
  ({ stem, loopNumber, fill, style = {} }) => {
    const { studio } = useTreeState()
    const loop = stem.loops[loopNumber]
    const isDrums = stem.type() === StemType.DRUMS
    const notes: INoteCollectionStore = isDrums
      ? loop.drumLoop.condensedNotesForVisualization
      : loop.melodicLoop.notes

    const canvasRef = useCanvasVisualizer(notes, studio.studioLoading, undefined, fill, isDrums)

    return (
      <div style={{ ...style }}>
        <canvas
          ref={canvasRef}
          style={{ height: '100%', width: '100%', boxSizing: 'border-box', opacity: 0.7 }}
        />
      </div>
    )
  }
)

interface Props {
  stemIndex: number
  section: number
  instrumentLoopWidthPX: number
  style?: React.CSSProperties
  className?: string
  usePlayer?: any
}

// Visualize a loop based on the stem and section it is located in within the studio
const LoopNoteVisualizer: FC<Props> = ({
  stemIndex,
  section,
  className,
  style,
  instrumentLoopWidthPX,
  usePlayer
}) => {
  const studio = usePlayer ? useTreeState().player : useTreeState().studio
  const stem = studio.song.stems[stemIndex]
  const isDrums = stem.type() === StemType.DRUMS
  const loop = stem.getLoopAtSectionOrNull(section)

  const notes: INoteCollectionStore = isDrums
    ? loop.drumLoop.condensedNotesForVisualization
    : loop.melodicLoop.notes

  const canvasRef = useCanvasVisualizer(
    notes,
    studio.studioLoading,
    instrumentLoopWidthPX,
    '#000000',
    isDrums
  )

  return (
    <div className={className || ''} style={style || {}}>
      <canvas
        ref={canvasRef}
        style={{ height: '100%', width: '100%', boxSizing: 'border-box', opacity: 0.3 }}
      />
    </div>
  )
}

export default observer(LoopNoteVisualizer)
